import React from "react";
import { motion } from "framer-motion";
import { useLang } from "../../i18n/LanguageContext";
import { S } from "../../data/strings";
import { COLLECTIONS } from "../../data/content";
import { SectionHead } from "./Ornament";
import { EASE } from "../../lib/motion";

// bento spans for first 7 items
const spans = [
  "sm:col-span-2 lg:row-span-2 lg:col-span-2",
  "",
  "",
  "",
  "",
  "sm:col-span-2 lg:col-span-2",
  "",
];

export const Collections = () => {
  const { t } = useLang();
  return (
    <section id="collections" data-testid="collections-section" className="bg-cream py-24 sm:py-32">
      <div className="mx-auto max-w-[1400px] px-6 sm:px-10">
        <SectionHead overline={S.collections.overline} heading={S.collections.heading} />

        <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 auto-rows-[240px] lg:auto-rows-[260px] gap-4">
          {COLLECTIONS.map((c, i) => (
            <motion.a
              key={`${c.id}-${i}`}
              href={`#${c.id}`}
              data-testid={`collection-card-${i}`}
              className={"group relative overflow-hidden rounded-lg border border-gold/20 " + (spans[i] || "")}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.15 }}
              transition={{ duration: 0.8, ease: EASE, delay: (i % 4) * 0.08 }}
            >
              <img
                src={c.img}
                alt={t(c.name)}
                loading="lazy"
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-burgundy/90 via-burgundy/25 to-transparent" />
              <div className="absolute inset-0 border border-transparent group-hover:border-gold/50 transition-colors duration-500 rounded-lg" />
              <div className="absolute inset-x-0 bottom-0 p-6">
                <h3 className="font-serif text-xl sm:text-2xl text-ivory leading-tight">{t(c.name)}</h3>
                <p className="mt-1.5 text-ivory/70 text-xs sm:text-sm max-w-xs line-clamp-2">{t(c.desc)}</p>
                <span className="mt-3 inline-flex items-center gap-1.5 font-cinzel text-[10px] tracking-luxe uppercase text-goldlight opacity-0 -translate-y-1 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-400">
                  {t(S.explore)} <span>&#8594;</span>
                </span>
              </div>
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
};
